import React from 'react';
import { Span } from '@bpba/ui-components';
import styled from 'styled-components';

const StyledDiv = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  lineHeight: '32px',
  fontSize: '20px',
  margin: 'auto',
});

const StyledMsg = styled.div<React.HTMLAttributes<HTMLDivElement>>({
  fontWeight: 600,
  color: 'white',
});

export const Result = ({ message }: { message?: string }) => {
  return (
    <StyledDiv>
      {message ? <StyledMsg dangerouslySetInnerHTML={{ __html: message }} /> : <Span>Por favor vuelva a intentarlo</Span>}
    </StyledDiv>
  );
};
